import React from 'react';
import { TimesButton } from '@fiverr-private/button';
import { atoms } from '@fiverr-private/theme';
import { LightboxHeaderCloseIconProps } from '../../types';

const LightboxHeaderCloseIcon = ({ onClick, dataTestId }: LightboxHeaderCloseIconProps) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick(e);
  };

  return (
    <TimesButton
      dataTestId={dataTestId}
      theme="light"
      shape="circle"
      onClick={handleClick}
      className={atoms({ marginLeft: 'auto' })}
    />
  );
};

export default LightboxHeaderCloseIcon;
